var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Market Segments")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "item-detail item-detail-profile" },
      _vm._l(_vm.stateMarketSegments, function (market_segment) {
        return _c("li", { key: market_segment }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("sentenceCase")(market_segment)) +
              "\n    "
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }